module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1357446"
    }
  }, [_c('b', [_vm._v("MINI GOUGÈRES")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1357946"
    }
  }, [_c('b', [_c('i', [_vm._v("In French bistros, diners are often presented with a small napkin-lined basket or plate filled with these cheese puffs known as gougères")])]), _vm._v(". "), _c('b', [_c('i', [_vm._v("Once you become familar with making the choux paste (batter), these puffs are sure to become part of your repertoire.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1360346"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes       Bake: 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1360846"
    }
  }, [_vm._v("6 ounces Gruyère or Swiss cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1361146"
    }
  }, [_vm._v("1 cup water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1361446"
    }
  }, [_vm._v("6 tablespoons butter or margarine, cut up")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1361746"
    }
  }, [_vm._v("1½ teaspoons Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1362946"
    }
  }, [_vm._v("½ teaspoon hot pepper sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1363846"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1364846"
    }
  }, [_vm._v("1 cup all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1365146"
    }
  }, [_vm._v("4 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1365646"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 400°F. Grease and flour two large cookie sheets. Shred Gruyère to equal 1 cup; finely dice remaining cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1366946"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In 3-quart saucepan, heat water, butter, mustard, hot pepper sauce, and salt to boiling. Remove saucepan from heat. With wooden spoon, vigorously stir in flour all at once until mixture forms ball and leaves side of pan.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1369046"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Add eggs, one at a time, beating well after each addition, until batter is smooth and satinlike. Stir in shredded and diced cheese. Drop batter by rounded teaspoons, about 2 inches apart, onto prepared cookie sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1371046"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Bake 30 to 35 minutes, rotating sheets between upper and lower racks halfway through baking, until deep golden. Transfer puffs to wire racks to cool. Serve warm or at room temperature. Makes about 48 puffs.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1373046"
    }
  }, [_vm._v("Each puff: About 60 calories, 3g protein, 3g carbohydrate, 4g total fat (2g saturated), 34mg cholesterol, 65mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1374046"
    }
  }, [_c('b', [_vm._v("CHEDDAR CURRY PUFFS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1374546"
    }
  }, [_vm._v("Prepare gougères as directed, but use "), _c('b', [_vm._v("Cheddar cheese ")]), _vm._v("in place of Gruyère cheese. Add "), _c('b', [_vm._v("2 teaspoons curry powder, ½ teaspoon ground coriander, ")]), _vm._v("and "), _c('b', [_vm._v("½ teaspoon ground cumin ")]), _vm._v("to water mixture in Step 2. Makes about 48 puffs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bf6d31d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c37_r1.vue
// module id = 177
// module chunks = 0